/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module AccountsModule
 */

import {
    AviPermissionResource,
    ITenant,
} from 'generated-types';

import { Tenant } from 'object-types';
import { ObjectTypeItem } from 'object-type-item';
import { withFullModalMixin } from 'ajs/js/utilities/mixins/with-full-modal.mixin';
import {
    TenantModalComponent,
} from 'ng/modules/accounts/components/tenant-modal/tenant-modal.component';

import * as globalL10n from 'global-l10n';
import { L10nService } from '@vmw/ngx-vip';
import { TenantConfigurationConfigItem } from 'message-items/tenant-configuration.config-item.factory';

const { ...globalL10nKeys } = globalL10n;

type TTenantPartial = Omit<ITenant, 'config_settings'>;

export interface ITenantConfig extends TTenantPartial {
    config_settings?: TenantConfigurationConfigItem,
}

interface ITenantData {
    config: ITenantConfig,
}

/**
 * @description Tenant Item.
 * @author Suraj Kumar
 */
export class TenantItem extends withFullModalMixin(ObjectTypeItem) {
    public static ajsDependencies = [
        'l10nService',
    ];

    public data: ITenantData;

    private readonly l10nService: L10nService;

    constructor(args = {}) {
        const extendedArgs = {
            objectName: 'tenant',
            objectType: Tenant,
            windowElement: TenantModalComponent,
            permissionName: AviPermissionResource.PERMISSION_TENANT,
            ...args,
        };

        super(extendedArgs);

        this.l10nService = this.getAjsDependency_('l10nService');
    }

    /**
     * @override
     */
    public isEditable(): boolean {
        return super.isEditable();
    }

    /**
     * Getter for config_settings.
     */
    public get configSettings(): TenantConfigurationConfigItem {
        return this.config.config_settings;
    }

    /** @override */
    public getModalBreadcrumbTitle(): string {
        return this.l10nService.getMessage(globalL10nKeys.tenantLabel);
    }
}
